<div class="position-relative w-100 padding">
    <app-header-detail></app-header-detail>
    <app-sub-detail></app-sub-detail>
    <app-sme-keys></app-sme-keys>
    <app-sme-services></app-sme-services>
    <app-sme-detail></app-sme-detail>
</div>
